document.addEventListener('change', function (event) {
  const picker = event.target.closest('[data-variant-picker]');
  if (!picker) return;
  const form = picker.closest('.sava-product-form');
  const variantData = form && form.querySelector('[data-product-variants]');
  if (!form || !variantData) return;
  const variants = JSON.parse(variantData.textContent || '[]');
  const choices = [...form.querySelectorAll('[data-variant-picker]:checked')].map((input) => input.value);
  const variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
  if (!variant) return;

  const select = form.querySelector('[data-variant-id]');
  if (select) select.value = variant.id;
  form.querySelectorAll('[data-selected-option]').forEach((item, index) => { item.textContent = choices[index] || ''; });
  const button = form.querySelector('[data-add-to-bag]');
  const price = form.closest('.sava-product-info').querySelector('[data-product-price]');
  const stock = form.querySelector('[data-stock-note]');
  const moneyFormat = (form.querySelector('[data-money-format]') || {}).dataset?.moneyFormat;
  const amount = (variant.price / 100).toFixed(2);
  const money = window.Shopify && window.Shopify.formatMoney
    ? window.Shopify.formatMoney(variant.price, moneyFormat)
    : moneyFormat
      ? moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      : amount;
  if (price) price.textContent = money;
  if (button) { button.disabled = !variant.available; button.textContent = variant.available ? `Add to bag — ${money}` : 'Sold out'; }
  if (stock) stock.textContent = variant.available ? 'In stock · Secure checkout' : 'This option is currently unavailable';
});

document.addEventListener('click', function (event) {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const isOpen = document.documentElement.classList.toggle('sava-menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', String(isOpen)));
  }
  const filterButton = event.target.closest('[data-filter-toggle]');
  if (filterButton) {
    const drawer = document.querySelector('[data-filter-drawer]');
    if (drawer) drawer.classList.toggle('is-open');
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && document.documentElement.classList.contains('sava-menu-open')) {
    document.documentElement.classList.remove('sava-menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
  }
});

/* Infinite scroll for product grids (collection, search, homepage feeds).
   Fetches the next page through Shopify's section rendering API so only
   the grid markup is transferred, which keeps a 10k+ product catalog fast. */
(function () {
  function loadMore(root) {
    const anchor = root.querySelector('[data-infinite-anchor]');
    if (!anchor || root.dataset.loading === 'true') return;
    const nextUrl = anchor.getAttribute('data-next-url');
    const sectionId = anchor.getAttribute('data-section-id');
    if (!nextUrl || !sectionId) return;
    root.dataset.loading = 'true';
    const loadingEl = anchor.querySelector('[data-loading]');
    const button = anchor.querySelector('[data-load-more]');
    if (loadingEl) loadingEl.hidden = false;
    if (button) button.hidden = true;
    const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    fetch(`${nextUrl}${separator}section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-infinite-grid]');
        const grid = root.querySelector('[data-infinite-grid]');
        if (newGrid && grid) grid.append(...newGrid.childNodes);
        const newAnchor = doc.querySelector('[data-infinite-anchor]');
        if (newAnchor) {
          anchor.replaceWith(newAnchor);
          observe(root, newAnchor);
        } else {
          anchor.outerHTML = '<p class="sava-end-of-feed">You have reached the end</p>';
        }
      })
      .catch(() => { if (button) button.hidden = false; })
      .finally(() => {
        root.dataset.loading = 'false';
        if (loadingEl) loadingEl.hidden = true;
      });
  }

  function observe(root, anchor) {
    if (!anchor || !anchor.getAttribute('data-next-url')) return;
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { observer.disconnect(); loadMore(root); }
      });
    }, { rootMargin: '800px 0px' });
    observer.observe(anchor);
  }

  document.querySelectorAll('[data-infinite-scroll]').forEach((root) => {
    observe(root, root.querySelector('[data-infinite-anchor]'));
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-load-more]')) loadMore(root);
    });
  });
})();

/* Older Theme Editor custom CSS used a fixed, beige image box. Keep product
   uploads fully visible in a consistent 2:3 retail frame until that setting is
   removed in the editor. Appending this after the document beats that legacy
   inline rule without changing a customer's uploaded image. */
const legacyImageFrameOverride = document.createElement('style');
legacyImageFrameOverride.id = 'sava-image-frame-override';
legacyImageFrameOverride.textContent = `
  .sava-product-card img { width:100% !important; height:auto !important; aspect-ratio:2 / 3 !important; object-fit:contain !important; object-position:center !important; background:transparent !important; }
  .sava-product-card__media { aspect-ratio:2 / 3 !important; background:transparent !important; }
  .sava-category-links img { width:100% !important; height:auto !important; aspect-ratio:1 / 1 !important; object-fit:contain !important; background:transparent !important; }
  .sava-gallery img { height:auto !important; aspect-ratio:2 / 3 !important; object-fit:contain !important; background:transparent !important; }
  .sava-hero__image, .sava-promo-card img { object-fit:cover !important; background:transparent !important; }
`;
document.body.appendChild(legacyImageFrameOverride);

document.addEventListener('click', function (event) {
  const tabButton = event.target.closest('[data-cat-tab]');
  if (!tabButton) return;
  const browser = tabButton.closest('.sava-cat-browser');
  if (!browser) return;
  const target = tabButton.getAttribute('data-cat-tab');
  browser.querySelectorAll('[data-cat-tab]').forEach((btn) => btn.classList.toggle('is-active', btn === tabButton));
  browser.querySelectorAll('[data-cat-panel]').forEach((panel) => {
    panel.hidden = panel.getAttribute('data-cat-panel') !== target;
  });
});
